var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9967 18.3212V3.33114C4.9967 2.8894 5.17218 2.46576 5.48454 2.15341C5.79689 1.84105 6.22054 1.66557 6.66227 1.66557H13.3245C13.7663 1.66557 14.1899 1.84105 14.5023 2.15341C14.8146 2.46576 14.9901 2.8894 14.9901 3.33114V18.3212H4.9967Z",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99672 9.99339H3.33116C2.88942 9.99339 2.46578 10.1689 2.15342 10.4812C1.84107 10.7936 1.66559 11.2172 1.66559 11.659V16.6557C1.66559 17.0974 1.84107 17.521 2.15342 17.8334C2.46578 18.1457 2.88942 18.3212 3.33116 18.3212H4.99672",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9901 7.49506H16.6557C17.0974 7.49506 17.5211 7.67054 17.8334 7.98289C18.1458 8.29524 18.3212 8.71889 18.3212 9.16062V16.6557C18.3212 17.0974 18.1458 17.5211 17.8334 17.8334C17.5211 18.1458 17.0974 18.3212 16.6557 18.3212H14.9901",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32782 4.9967H11.659",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32782 8.32784H11.659",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32782 11.659H11.659",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32782 14.9901H11.659",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9868,
    height: 19.9868,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.36610c85073ec0d95ea3190a5f033965.svg";
export { ForwardRef as ReactComponent };